/* eslint-disable camelcase */
export default {
  no_metabase: "No Metabase Data",
};
